export default __webpack_public_path__ + "static/media/phone_bg_front.6a14a36d.png";